import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// React Flow uses ResizeObserver to measure nodes. When nodes change rapidly the
// browser fires "ResizeObserver loop completed with undelivered notifications."
// Wrapping callbacks in requestAnimationFrame defers them to the next frame,
// which is the canonical way to eliminate the loop entirely.
if (window.ResizeObserver) {
    const _RO = window.ResizeObserver;
    window.ResizeObserver = class ResizeObserver extends _RO {
        constructor(cb) {
            super((entries, observer) => {
                requestAnimationFrame(() => {
                    if (entries.length) cb(entries, observer);
                });
            });
        }
    };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
